import { useAuth } from '@montel/montelpro-auth';
import React, { FunctionComponent } from 'react';

interface AccessControlProps {
	allowedRoles: string[];
	children: React.ReactNode;
}

export const AccessControl: FunctionComponent<AccessControlProps> = ({
	allowedRoles,
	children,
}) => {
	const { user } = useAuth();

	if (!user) {
		return null;
	}

	if (user.roles?.some((role: string) => allowedRoles.includes(role))) {
		return <>{children}</>;
	}

	return null;
};
